import {Injectable} from '@angular/core';
import {GroupsActions} from './actions/groups-actions.service';
import {GroupsRestService} from './apis/groups-rest.service';
import {AcDialogService, AcDropdownChild, GeneralService} from 'ac-infra';
import {TenantsRestService} from './apis/tenants-rest.service';
import {ChannelsRestService} from './apis/channels-rest.service';
import {AuthorizationService} from '../../common/services/authorization.service';
import {DevicesActionsService} from './actions/devices-actions.service';
import {cloneDeep} from 'lodash';
import {TenantsActionsService} from "./actions/tenants-actions.service";
import {ConstantStringsService} from "../../common/utilities/constant-strings.service";
import {
    EntitySelectionDialogComponent,
    EntitySelectionDialogObject
} from "../dialogs/entity-selection-dialog/entity-selection-dialog.component";
import {FilterUtilsService} from "./filter-utils.service";

@Injectable({providedIn: 'root'})
export class ServiceActionsMenuService {

    isSystemAdminOrOperator: Function;
    isServiceProvider: Function;
    isCustomerOperator: Function;
    isMonitor: Function;
    isChannelOrCustomerOperator: Function;
    isChannelOperator: Function;
    editButtonText;
    editText;
    actionForLiveTeamCloudServiceOnly = false;
    actionsForSingleSelection = false;
    oneIsSmartTap = false;
    selection;
    lcCustomers;
    oneLCCustomerIsChosenFromTheLCCustomersTable = false;
    notEssentialAndNotOCBasic;
    isDeployStatusAllowed;
    changeCustomerTitle = 'Change Customer';
    oneSelectedNotMonitorNotChannelNotCustomerOperators;

    constructor(private groupsActions: GroupsActions,
                private groupsRestService: GroupsRestService,
                private tenantsRestService: TenantsRestService,
                private channelsRestService: ChannelsRestService,
                private filterUtilsService: FilterUtilsService,
                private devicesActionsService: DevicesActionsService,
                private generalService: GeneralService,
                private acDialogService: AcDialogService,
                private tenantsActionsService: TenantsActionsService,
                private authorizationService: AuthorizationService) {
        this.updatePermissions();
    }

    updatePermissions = () => {
        this.isSystemAdminOrOperator = this.authorizationService.isSystemAdminOrOperatorLevel;
        this.isServiceProvider = this.authorizationService.validForServiceProvider;
        this.isCustomerOperator = this.authorizationService.validForCustomerOperator;
        this.isMonitor = this.authorizationService.isMonitor;
        this.isChannelOperator = this.authorizationService.isChannelLevel;
        this.isChannelOrCustomerOperator = () => {
            return this.authorizationService.validForChannel() || this.authorizationService.validForCustomerOperator();
        };
        this.oneSelectedNotMonitorNotChannelNotCustomerOperators = this.selection?.length === 1 && !this.isMonitor() && !this.isChannelOrCustomerOperator();
        this.editButtonText = (this.generalService.isViewMode ? 'View' : 'Edit') + ' Service';
        this.editText = (this.generalService.isViewMode ? 'View' : 'Edit') + ' Direct Routing Service';
    };

    updateServiceSelection = (selection) => {
        this.selection = selection;
        this.isDeployStatusAllowed = !!(this.selection?.length > 0  && this.selection.some((service) => {
            const deployStatus =  service?.applicationsStatus?.management?.serviceDeployStatus;
            return !['INPROGRESS_RESOURCE_ALLOCATION', 'INPROGRESS_ACCOUNT_CREATION', 'INPROGRESS_AWAIT_CONCENT', 'DELETING', 'IN_PROGRESS'].includes(deployStatus);
        }))
    };

    getServiceItems = (type): AcDropdownChild[] => {
        const serviceItems = [
            {
                displayName: this.editButtonText,
                enabled: !this.generalService.isViewMode && !this.isCustomerOperator() && !this.isMonitor() && this.selection?.length === 1 && this.selection[0].serviceSource === type && this.isDeployStatusAllowed,
                onClick: (lcCustomer) => this.groupsActions.serviceAction({lcCustomer, service: this.selection[0] , page: this.generalService.isViewMode ? 'overview' : 'edit', type})
            },
            {
                displayName: 'View Service',
                enabled: !this.isCustomerOperator() && this.selection?.length === 1 && this.selection[0].serviceSource === type,
                onClick: (lcCustomer) => this.groupsActions.serviceAction({lcCustomer, service: this.selection[0] , page: 'overview', type})
            },
            {
                displayName: 'Open Management Portal',
                enabled: !this.isCustomerOperator() && (!this.selection || this.selection.length === 0 || (this.selection?.length === 1 && this.selection[0].serviceSource === type)),
                onClick: (lcCustomer) => this.groupsActions.serviceAction({lcCustomer, service: this.selection?.[0] , page: 'management', type})
            },
            {
                displayName: 'Open Service Portal',
                enabled: this.selection?.length === 1 && this.selection[0].serviceSource === type && this.isDeployStatusAllowed,
                onClick: (lcCustomer) => this.groupsActions.serviceAction({lcCustomer, service: this.selection[0] ,
                    page: 'customer', type, skipGetToken: true})
            },
            {
                displayName: this.changeCustomerTitle,
                enabled: false, //this.oneSelectedNotMonitorNotChannelNotCustomerOperators,
                onClick: () => this.changeCustomer(this.selection[0], type),
                skipPreClick: true
            }
        ];

        return serviceItems;
    };

    getDirectRoutingItems = (actionsForSingleSelection): AcDropdownChild[] => {
        this.oneIsSmartTap = this.selection?.some((service) => service.serviceSource === 'SMART_TAP');
        this.actionsForSingleSelection = actionsForSingleSelection;

        this.actionForLiveTeamCloudServiceOnly = this.actionsForSingleSelection ? (this.selection[0].licenseType !== 'OC_BASIC' && this.selection[0].licenseType !== 'ZOOM') : false;
        this.notEssentialAndNotOCBasic = this.actionsForSingleSelection ? this.selection[0].licenseType !== 'OC_BASIC' && this.selection[0].licenseType !== 'ESSENTIAL' : false;
        return [
            {
                displayName: 'Open UMP Page',
                enabled: this.authorizationService.isTenantUser() || this.authorizationService.isChannelLevel(),
                onClick: (lcCustomer) => this.openUMPPage(lcCustomer)
            },
            {
                displayName: this.editButtonText,
                enabled: !this.oneIsSmartTap && this.actionsForSingleSelection && this.selection[0].serviceSource === 'LTC' && this.actionForLiveTeamCloudServiceOnly,
                onClick: (lcCustomer) => this.groupsActions.editService(lcCustomer, undefined, this.selection[0])
            },
            {
                displayName: this.editButtonText + ' DIDs',
                enabled: !this.oneIsSmartTap && this.isCustomerOperator() && this.actionsForSingleSelection && this.actionForLiveTeamCloudServiceOnly,
                onClick: (lcCustomer) => this.groupsActions.editService(lcCustomer, 'did', this.selection[0])
            },
            {
                displayName: 'Backup Service',
                enabled: !this.oneIsSmartTap && !this.isMonitor() && this.isSystemAdminOrOperator() && this.actionsForSingleSelection && this.selection?.[0].serviceSource === 'LTC' && this.notEssentialAndNotOCBasic,
                onClick: () => this.backupServices(),
                skipPreClick: true
            },
            {
                displayName: 'Restore Service',
                enabled: !this.oneIsSmartTap && !this.isMonitor() && this.isSystemAdminOrOperator() && this.actionsForSingleSelection && this.selection?.[0].serviceSource === 'LTC' && this.notEssentialAndNotOCBasic,
                onClick: () => this.restoreServices(),
                skipPreClick: true
            },
            {
                displayName: 'Delete Teams',
                enabled: !this.oneIsSmartTap && !this.isCustomerOperator() && !this.isMonitor() && this.actionsForSingleSelection && this.selection[0].serviceSource === 'LTC' && this.actionForLiveTeamCloudServiceOnly,
                onClick: () => this.deleteTeamsSide(),
                skipPreClick: true
            },
            {
                displayName: 'Delete ' + ConstantStringsService.linkOrProviderSide,
                enabled: !this.oneIsSmartTap && !this.isCustomerOperator() && !this.isMonitor() && this.actionsForSingleSelection && this.selection[0].serviceSource === 'LTC' && this.actionForLiveTeamCloudServiceOnly,
                onClick: () => this.deleteServiceProvider(),
                skipPreClick: true
            },
            {
                displayName: this.changeCustomerTitle,
                enabled: this.oneSelectedNotMonitorNotChannelNotCustomerOperators,
                onClick: () => this.changeCustomer(this.selection[0], 'LTC'),
                skipPreClick: true
            }
        ];
    };

    getDeviceManagerItems = (actionsForSingleSelection): AcDropdownChild[] => {
        this.actionsForSingleSelection = actionsForSingleSelection;
        return [
            {// shay requested to change name from configure endpoints to Open Management Page and to be first.... gal approved
                displayName: 'Open Management Page',
                enabled: true,
                onClick: () => this.groupsActions.openGeneralDeviceManagerPage(this.selection?.length === 1 && this.selection[0].serviceSource === 'DM' && this.selection[0])
            },
            {
                displayName: 'Edit Service',
                enabled: !this.isMonitor() && this.selection?.length === 1 && this.selection[0].serviceSource === 'DM',
                onClick: (lcCustomer) => this.addEditDeviceManagerService(lcCustomer, this.selection[0])
            },
            {
                displayName: 'Disable Service',
                enabled: !this.isMonitor() && !this.isCustomerOperator() && this.actionsForSingleSelection && this.selection[0].serviceSource === 'DM',
                onClick: () => this.groupsActions.disableService(this.selection[0]),
                skipPreClick: true
            },
            {
                displayName: this.changeCustomerTitle,
                enabled: this.oneSelectedNotMonitorNotChannelNotCustomerOperators,
                onClick: () => this.changeCustomer(this.selection[0], 'DM'),
                skipPreClick: true
            }
        ];
    };

    getHybridItems = (type: string): AcDropdownChild[] => {
        return [
            {
                displayName: 'Edit',
                enabled: this.selection?.length === 1 && !this.authorizationService.isCustomerOperatorLevel() &&
                    (['HYBRID_ENTITIES', 'LIVEOPS_360_MANAGEMENT'].includes(this.selection[0].serviceSource)),
                onClick: () => this.groupsActions.editServiceSettings({service: this.selection[0], type}),
                skipPreClick: true
            },
            {
                displayName: 'Add AC Device',
                enabled: true,
                onClick: () => this.devicesActionsService.addDevice({deviceDialogType: 'AC',
                    isServiceAttached: true, serviceId: this.selection?.length === 1 ? this.selection[0].id : undefined}),
                skipPreClick: true
            },
            {
                displayName: 'Add Multiple AC Devices',
                enabled: true,
                onClick: () => this.devicesActionsService.addDevice({deviceDialogType: 'AC',
                    isMultiple: true, isServiceAttached: true, serviceId: this.selection?.length === 1 ? this.selection[0].id : undefined}),
                skipPreClick: true
            },
            {
                displayName: this.changeCustomerTitle,
                enabled: this.oneSelectedNotMonitorNotChannelNotCustomerOperators && type === 'HYBRID_ENTITIES',
                onClick: () => this.changeCustomer(this.selection[0], 'HYBRID_ENTITIES'),
                skipPreClick: true
            }
        ];
    };

    getVocaItems = (): AcDropdownChild[] => {
        return [
            {
                displayName: 'Edit Service',
                enabled: !this.isMonitor() && !this.isCustomerOperator() && this.selection?.length === 1 && this.selection[0].serviceSource === 'VOCA',
                onClick: (lcCustomer) => this.groupsActions.openVocaPage({lcCustomer, uri: 'Services', service: this.selection[0]})
            },
            {
                displayName: 'Open Management Portal',
                enabled: !this.isMonitor() && this.selection?.length === 1 && this.selection[0].serviceSource === 'VOCA',
                onClick: (lcCustomer) => this.groupsActions.openVocaPage({lcCustomer, uri: 'Services', service: this.selection[0], page: 'management'})
            },
            {
                displayName: 'Configure SP License',
                enabled: !this.isMonitor() && this.isSystemAdminOrOperator(),
                onClick: () => {
                    this.chooseTenantAndPreformAction({pageName: 'openVocaSPPage', type: 'VOCA'});
                },
                skipPreClick: true
            },
            {
                displayName: 'Configure Provider License',
                enabled: !this.isMonitor() && !this.isChannelOrCustomerOperator(),
                onClick: () => {
                    this.chooseChannelAndPreformAction({pageName: 'openVocaChannelPage', type: 'VOCA'});
                },
                skipPreClick: true
            },
        ];
    };

    getZoomItems = (serviceType): AcDropdownChild[] => {
        return [
            {
                displayName: serviceType === 'ZOOM' ? 'Open Qualified Leads Page' : 'Open Services Page',
                enabled: !this.isCustomerOperator(),
                onClick: () => {
                    this.chooseTenantAndPreformAction({pageName: 'openZoomQualifiedLeadsPage', type: serviceType});
                },
                skipPreClick: true
            },
            {
                displayName: 'Open Number Management Page',
                enabled: !this.isCustomerOperator() && serviceType !== 'LIVEOPS_360',
                onClick: () => {
                    this.chooseTenantAndPreformAction({pageName: 'openZoomNumbersPage', type: serviceType});
                },
                skipPreClick: true
            },
            {
                displayName: 'Open Customer Page',
                enabled: this.isCustomerOperator() && serviceType !== 'LIVEOPS_360',
                onClick: (lcCustomer) => this.groupsActions.openZoomPage({lcCustomer, pageName: 'customer', serviceType})
            },
            {
                displayName: this.changeCustomerTitle,
                enabled: this.oneSelectedNotMonitorNotChannelNotCustomerOperators,
                onClick: () => this.changeCustomer(this.selection[0], serviceType),
                skipPreClick: true
            }
        ];
    };

    openUMPPage = (lcCustomer) => {
        this.groupsActions.getUMPDeviceAndOpenSSOConnection({actionName: 'EMS_login', selectedTenantId: lcCustomer.tenantId});
    };

    deleteServiceProvider = () => {
        this.groupsActions.deleteProviderSide(this.selection[0]);
    };

    deleteTeamsSide = () => {
        this.groupsActions.deleteTeamsSide(this.selection[0]);
    };

    backupServices = () => {
        this.groupsRestService.serviceRestAction(() => {
        }, () => {
        }, this.selection, 'backupService');
    };

    restoreServices = () => {
        this.groupsRestService.serviceRestAction(() => {
        }, () => {
        }, this.selection, 'restoreService');
    };

    changeCustomer = (service, type) => {
        this.groupsActions.openSelectCustomersDialog(service, type);
    };

    customerSelection = (type, action, service = undefined) => {
        const prefix = (type.key === 'addService' ? type : action)?.displayName;
        const postFix = (type.key === 'addService' ? action : type)?.displayName;
        const dialogTitle = prefix && postFix ? (prefix + ' (' + postFix + ')') : 'Select Customer';
        let lcCustomers = cloneDeep(this.lcCustomers);
        service = service || (this.selection?.length === 1 && type.key !== 'addService' ? this.selection[0] : undefined);
        if(!lcCustomers || lcCustomers.length === 0){
            lcCustomers = this.groupsActions.getLCCustomersThatTheirServiceIsEnabled({serviceType: (type?.key !== 'addService' ? type.key : action?.key)});
        }

        if(type.key === 'addService' && action.key === 'VOCA'){
            lcCustomers = lcCustomers.filter((lcCustomer) => lcCustomer.channelId > 0);
        }

        this.groupsActions.getLCCustomer(action.key, this.oneLCCustomerIsChosenFromTheLCCustomersTable, lcCustomers, service, dialogTitle, (lcCustomer) => {
            const tenant = this.tenantsRestService.getEntityById(lcCustomer.tenantId);
            if(type.key === 'addService' && tenant.isCommitmentEnabled){
                delete lcCustomer.preconfigId;
                delete tenant.preconfigId;
                this.groupsActions.openServiceCommercialInfoDialog({tenant, lcCustomer, action});
            }else{
                action.onClick(lcCustomer);
            }
        });
    };

    public addEditDeviceManagerService(lcCustomer = undefined, service = undefined) {
        const page = service ? 'edit_customer' : 'create_customer';
        let channelMsTenantId;
        if (page === 'create_customer' && this.authorizationService.validForChannel()) {
            const channels = this.channelsRestService.getAllEntities();
            channelMsTenantId = channels.length === 1 ? channels[0]?.msTenantId : undefined;
        }

        this.groupsActions.openDeviceManagerPage(page, lcCustomer.tenantId, service?.serviceId, channelMsTenantId, lcCustomer);
    }

    chooseTenantAndPreformAction = ({pageName, spAttachedTenant = undefined, type}) => {
        const tenantId =  this.selection?.length === 1 ? this.selection[0]?.tenantId : undefined;
        const tenant = tenantId ? this.tenantsRestService.getEntityById(tenantId) : undefined;
        if (spAttachedTenant || tenant) {
            this.doActionByType({pageName, tenant: spAttachedTenant || tenant, type});
        }else {
            const tenants = this.tenantsRestService.getAllEntities().filter(tenant => tenant.services?.[type]?.enabled);
            const filteredTenant = this.filterUtilsService.getSelectedTopologyItem();
            const foundTenant = filteredTenant && !filteredTenant.tenantId && tenants.find((tenant) => tenant.id === filteredTenant.id);
            const dialogData: EntitySelectionDialogObject = {entity: {id: foundTenant?.id || undefined, name: ''}, items: tenants, selectLabel: 'Tenants', dialogType: 'tenant'};

            if(type === 'VOCA') {
                dialogData.serviceType = type;
                dialogData.subRegion = {value: -2};
            }

            this.acDialogService.open(EntitySelectionDialogComponent, {
                onSubmit: ({entity}) => {
                    if(entity?.id){
                        const tenant = this.tenantsRestService.getEntityById(entity.id);

                        if(dialogData.serviceType === 'VOCA') {
                            tenant.subRegion = dialogData.subRegion.value;
                        }

                        this.doActionByType({pageName, tenant, type});
                    }
                },
                dialogData,
                id: 'select-tenants-dialog',
                title: 'Select Tenant',
                submitButtonText: 'Select'
            });
        }
    };

    chooseChannelAndPreformAction = ({pageName, type}) => {
        const channels = this.channelsRestService.getAllEntities().filter(channel => channel.services?.[type]?.enabled);

        const filteredChannel = this.filterUtilsService.getSelectedLiveEntity('channel');
        const foundChannel = filteredChannel && channels.find((channel) => channel.id === filteredChannel.id);
        const dialogData: EntitySelectionDialogObject = {
            entity: {id: foundChannel?.id || undefined, name: ''},
            items: channels,
            selectLabel: 'Channels',
            dialogType: 'channel'
        };

        if(type === 'VOCA') {
            dialogData.serviceType = type;
            dialogData.subRegion = {value: -2};
        }

        this.acDialogService.open(EntitySelectionDialogComponent, {
            onSubmit: ({entity}) => {
                if(entity?.id){
                    const channel = this.channelsRestService.getEntityById(entity.id);

                    if(dialogData.serviceType === 'VOCA') {
                        channel.subRegion = dialogData.subRegion.value;
                    }

                    this.doActionByType({pageName, channel, type});
                }


            },
            dialogData,
            id: 'select-channels-dialog',
            title: 'Select Channel',
            submitButtonText: 'Select'
        });
    };

    doActionByType = ({pageName, tenant = undefined, channel = undefined, type}) => {
        if (tenant?.services?.[type]?.enabled || channel?.services?.[type]?.enabled) {
            switch (pageName) {
                case 'editOperatorConnectJSON':
                    this.tenantsActionsService.editOperatorConnect(tenant);
                    break;
                case 'downloadOperatorConnectJSON':
                    this.tenantsActionsService.downloadOperatorConnectJSON(tenant);
                    break;
                case 'openZoomQualifiedLeadsPage':
                    tenant.type = type;// gal and ran decided that zoom and oc leads page will not have commitment until further notice
                    // if(tenant.isCommitmentEnabled) {
                    //     this.groupsActions.openServiceCommercialInfoDialog({tenant, action: this.openZoomQualifyLeads});
                    // }else{
                        this.openZoomQualifyLeads(tenant);
                    // }
                    break;
                case 'openZoomNumbersPage':
                    this.groupsActions.openZoomPage({tenant, pageName: 'numbers', serviceType: type});
                    break;
                case 'ocQualifyLeads':
                    // gal and ran decided that zoom and oc leads page will not have commitment until further notice
                    // if(tenant.isCommitmentEnabled) {
                    //     this.groupsActions.openServiceCommercialInfoDialog({tenant, action: this.openOCQualifyLeads});
                    // }else{
                        this.openOCQualifyLeads(tenant);
                    // }
                    break;
                case 'openVocaSPPage':
                    this.groupsActions.openVocaPage({tenant, uri: 'ServiceProviders'})
                    break;
                case 'openVocaChannelPage':
                    this.groupsActions.openVocaPage({channel, uri: 'Providers'})
                    break;
            }
        } else {
            this.acDialogService.info('Operator Connect is not enabled for the assigned tenant');
        }
    };

    openOCQualifyLeads = (tenant) => {
        this.groupsActions.getUMPDeviceAndOpenSSOConnection({
            actionName: 'ovoc_ovl_edit',
            selectedTenantId: tenant.id,
            pageName: 'ocQualifyLeads',
            preconfigId: tenant?.preconfigId
        });
    }

    openZoomQualifyLeads = (tenant) => {
        this.groupsActions.openZoomPage({tenant, pageName: 'leads', serviceType: tenant?.type});
    }
}
